import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import LabelTxtFieldInfo from './LabelTxtFieldInfo';



function NotesMdl({ modalOpen, handleMdlSave, handleModalClose, payload }) {
    const theme = useTheme();

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        handleMdlSave({ editRemarks: inputObject.editRemarks });
    }


    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {payload ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={2.5}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Edit Notes</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <LabelTxtFieldInfo name="editRemarks" title="Notes" width={"100%"} borderRadius={1} rows={4} multiline={true} height={100} />
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>  CANCEL</Button>
                            <Button variant="contained" type='submit' sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}> SAVE</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>}
        </Modal>
    )
}

export default NotesMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};


